import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-charcoal text-white py-20 px-4" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        {/* Brand mark */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-12 border-b border-white/10" data-id="element-25">
          <div className="flex items-center gap-4" data-id="element-26">
            <div className="bg-cream rounded-full p-3 flex items-center justify-center" data-id="element-27">
              <img src="https://cdn.magicpatterns.com/uploads/4sDEekiyXVshgNeog3yRkY/Adobe_Express_-_file.png" alt="Birdie Bag" className="w-12 h-12 object-contain" data-id="element-28" />
            </div>
            <div data-id="element-29">
              <div className="font-display text-3xl font-bold" data-id="element-30">Birdie Bag</div>
              <div className="text-sm text-white/60 mt-1" data-id="element-31">
                Putting Plastic Out of Play.
              </div>
            </div>
          </div>

          <div className="flex gap-5" data-id="element-32">
            <a href="https://www.instagram.com/birdiebagofficial/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-green hover:text-green transition-colors" aria-label="Instagram @birdiebagofficial" data-id="element-33">
              <InstagramIcon className="w-5 h-5" data-id="element-34" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 py-12" data-id="element-35">
          <div data-id="element-36">
            <h3 className="font-display text-lg mb-4" data-id="element-37">Explore</h3>
            <ul className="space-y-2" data-id="element-38">
              <li data-id="element-39">
                <a href="#mission" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-40">
                  Mission
                </a>
              </li>
              <li data-id="element-41">
                <a href="#product" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-42">
                  Product
                </a>
              </li>
              <li data-id="element-43">
                <a href="#faq" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-44">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-45">
            <h3 className="font-display text-lg mb-4" data-id="element-46">Contact</h3>
            <ul className="space-y-3" data-id="element-47">
              <li data-id="element-48">
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=contact@birdiebagco.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm" data-id="element-49">
                  <MailIcon className="w-4 h-4" data-id="element-50" />
                  contact@birdiebagco.com
                </a>
              </li>
              <li data-id="element-51">
                <a href="https://www.instagram.com/birdiebagofficial/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm" data-id="element-52">
                  <InstagramIcon className="w-4 h-4" data-id="element-53" />
                  @birdiebagofficial
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-white/10 text-sm text-white/50" data-id="element-54">
          <div data-id="element-55">© 2026 Birdie Bag. Made with care in Europe.</div>
          <div className="flex gap-6" data-id="element-56">
            <a href="#privacy" className="hover:text-white transition-colors" data-id="element-57">
              Privacy
            </a>
            <a href="#terms" className="hover:text-white transition-colors" data-id="element-58">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}